import { useState } from 'react';
import { Link } from 'react-router-dom';
import COVER_IMAGE from "../assets/login_image.jpg";

// ForgotPassword component handles password reset functionality
const ForgotPassword = () => {
  // State management
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Handle form submission for password reset
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.text();
      if (!response.ok) throw new Error(data || 'Failed to send reset email.');
      setSuccess(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-screen flex items-start">
      {/* Left side - Cover image */}
      <div className="relative w-1/2 h-full flex flex-col">
        <div className="absolute top-[20%] left-[10%] flex flex-col">
          <h1 className="text-4xl text-white font-bold my-4">Reset Password</h1>
          <p className="text-xl text-white font-normal">Enter your email to reset your password</p>
        </div>
        <img src={COVER_IMAGE} className="w-full h-full object-cover" alt="Cover" />
      </div>

      {/* Right side - Form */}
      <div className="w-1/2 h-full bg-[#F5F5F5]">
        <div className="p-20 flex flex-col justify-between h-full">
          <h1 className="text-xl font-semibold">SwopShop</h1>

          <div className="flex flex-col max-w-[550px]">
            {success ? (
              // Success message
              <div className="bg-green-50 border-l-4 border-green-500 p-4">
                <p className="text-sm text-green-700">
                  If an account exists with that email, you will receive password reset instructions.
                </p>
              </div>
            ) : (
              // Reset password form
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email address
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full py-2 my-2 bg-transparent border-b border-black outline-none focus:border-blue-500"
                    required
                    disabled={loading}
                  />
                </div>

                {/* Error message */}
                {error && (
                  <div className="bg-red-50 border-l-4 border-red-500 p-4">
                    <p className="text-sm text-red-700">{error}</p>
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className={`w-full bg-[#060606] text-white rounded-md p-4
                    ${loading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'}`}
                >
                  {loading ? 'Sending...' : 'Send Reset Instructions'}
                </button>
              </form>
            )}

            {/* Navigation links */}
            <div className="mt-4 text-center">
              <Link to="/" className="text-sm font-medium text-gray-600 hover:text-gray-900">
                Back to Login
              </Link>
            </div>
          </div>

          <p className="text-center text-sm text-gray-600">
            Remember your password? <Link to="/" className="font-medium text-blue-600 hover:text-blue-500">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;